export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Vendor\",\n    \"label_plural\": \"{{count}} Vendors\"\n}\n"